import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ExtensionTypeOption } from 'src/app/pages/extension-register/models/extension-type-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { extensionTypeOptionSelectors } from '../state/extension-type-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: ExtensionTypeSelectComponent,
        },
    ],
    selector: 'ndt-extension-type-select',
    templateUrl: './extension-type-select.component.html',
    standalone: false
})
export class ExtensionTypeSelectComponent extends LcsSingleSelectBase<ExtensionTypeOption> implements OnInit {
   extensionTypes: Observable<ExtensionTypeOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.extensionTypes = this.store.pipe(
         select(extensionTypeOptionSelectors.selectFilteredItems),
         this.itemsLoaded()
      );
   }

   displayWith(item: ExtensionTypeOption | null): string | null {
      return item ? item.displayName : null;
   }

   trackBy(item: ExtensionTypeOption | null) {
      return item ? item.extensionTypeId : null;
   }
}
